import GroupIcon from "@mui/icons-material/Group";
import HomeIcon from "@mui/icons-material/Home";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import { styled } from "@mui/material/styles";
import * as React from "react";
import Badge from "@mui/material/Badge";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import "./BottomNav.css";

const CustomBottomNavigationAction = styled(BottomNavigationAction)(() => ({
  "& .MuiBottomNavigationAction-label": {
    color: "var(--text-color)", // Use CSS variable for label color
  },
}));
const BottomNav = ({ currentPage, setCurrentPage, isUserOnIos }) => {
  const handleChange = (_, newValue) => {
    setCurrentPage(newValue);
  };

  const iconStyle = {
    color: "var(--text-color)",
  };

  return (
    <BottomNavigation
      className="bottomNav"
      value={currentPage}
      onChange={handleChange}
      style={{
        paddingBottom: isUserOnIos ? ".75rem" : "",
        display: "flex", // Ensure flexbox layout is enforced
        justifyContent: "space-evenly", // Distribute items more evenly across the width
        alignItems: "center", // Vertically center items
        width: "100%", // Ensure it takes up the full width
      }}
    >
      <CustomBottomNavigationAction
        label="Home"
        value="home"
        icon={<HomeIcon sx={iconStyle} />}
      />
      <CustomBottomNavigationAction
        label="Friends"
        value="friends"
        icon={
          <Badge
            color="error" // This makes the badge red
            variant={false ? "dot" : undefined} // Show dot if there are new friend requests, add function when sockets.
            overlap="circular"
          >
            <GroupIcon sx={iconStyle} />
          </Badge>
        }
      />
      <CustomBottomNavigationAction
        label="Account"
        value="account"
        icon={<AccountCircleIcon sx={iconStyle} />}
      />
    </BottomNavigation>
  );
};

export default BottomNav;
